import * as React from 'react';
import { ProductOverviewData } from './types';
import LessonSamples from './lesson_samples';
import QuestionSamples from './question_samples';
import SignupForm from './signup_form';
import ProgressBar from '@magoosh/lib/progress_bar';
import { PrimaryButton } from '@magoosh/lib/button';
import { initializeSignupForm } from '@magoosh/organisms/signup_form/actions';
import configureStore from '@magoosh/store';
import { Provider } from 'react-redux';
import { paths } from 'config/path_helpers';
import * as Row from 'react-bootstrap/lib/Row';
import { Col } from 'react-bootstrap';
import style from './style.module.scss';

export default class ProductOverview extends React.Component<ProductOverviewData> {
  store = configureStore();

  state = {
    currentStep: this.props.startingStep
  };

  constructor(props) {
    super(props);
    this.store.dispatch(initializeSignupForm(props));
  }

  stepDescriptions = [
    <div>
      <h1>Watch and Learn</h1>
      <p>
        Magoosh’s expert instructors cover every topic on the ACT, broken up into short, easy-to-follow video
        lessons
      </p>
      <ul>
        <li>
          <strong>Learn strategies the test-makers won’t tell you.</strong> Get proven tips for pacing,
          guessing, and finding shortcuts.
        </li>
        <li>
          <strong>Study at your own pace.</strong> Fast or slow, you’re in control. Read transcripts, add
          notes, and flag for review.
        </li>
        <li>
          <strong>Get the review you need.</strong> Advanced trig? Comma splices? If there’s a concept you
          missed in class, we’ll teach it fast and make it stick.
        </li>
      </ul>
    </div>,

    <div>
      <h1>Practice, Learn, Improve</h1>
      <p>
        ACT prep is nothing without practice. Our questions are just like the real test and give you detailed
        feedback to improve.
      </p>
      <ul>
        <li>
          <strong>Practice till it clicks.</strong> Magoosh premium has over 1,500 practice questions, so you
          can keep improving day after day.
        </li>
        <li>
          <strong>Train with the most effective questions.</strong> We continually check for quality based on
          millions of answers from students like you.
        </li>
        <li>
          <strong>Never get stuck.</strong> Get instant feedback—every practice ACT question has step-by-step
          video and text explanations.
        </li>
      </ul>
    </div>,

    <div>
      <h1>Stay on Track</h1>
      <p>Get the tools you need to stay focused all the way through exam day.</p>
      <ul>
        <li>
          <strong>Track your progress.</strong> Identify strengths and weaknesses and see your score estimates
          improve as you practice.
        </li>
        <li>
          <strong>Study anywhere.</strong> Prep any time on any web browser, or with our Android and iOS apps.
        </li>
        <li>
          <strong>Keep yourself accountable.</strong> Schedule text message reminders to study, or email a
          tutor if you're feeling stuck.
        </li>
      </ul>
    </div>
  ];

  stepSamples = [
    <LessonSamples lessons={this.props.lessons} />,
    <QuestionSamples questions={this.props.questions} />,
    <SignupForm authenticityToken={this.props.authenticityToken} />
  ];

  render() {
    return (
      <Provider store={this.store}>
        <Row className={style.productOverview}>
          <Col md={6}>
            <div className={style.descriptionContainer}>{this.stepDescriptions[this.state.currentStep]}</div>
          </Col>
          <Col md={6}>{this.stepSamples[this.state.currentStep]}</Col>
        </Row>
        {this.renderNav()}
      </Provider>
    );
  }

  onClickContinue() {
    this.setState({ currentStep: this.state.currentStep + 1 });
    window.scrollTo(0, 0);
  }

  onClickBack() {
    this.setState({ currentStep: this.state.currentStep - 1 });
    window.scrollTo(0, 0);
  }

  renderNav() {
    return (
      <div className={style.nav}>
        <div className={style.navProgress}>
          <div className={style.progressMeter}>
            <p>Step {this.state.currentStep + 1} of 3</p>
            <ProgressBar
              backgroundColor="#d8d8d8"
              color="#26B67C"
              percentage={((this.state.currentStep + 1) / 3) * 100}
              size="sm"
            />
          </div>
          <div>
            {this.state.currentStep < 2 && (
              <PrimaryButton onClick={() => this.onClickContinue()}>Continue</PrimaryButton>
            )}
          </div>
        </div>
        <div className={style.navLinks}>
          {this.state.currentStep > 0 && (
            <a className="pull-left" onClick={() => this.onClickBack()}>
              {'<< Back'}
            </a>
          )}
          <a className="pull-right" href={paths.guestAccess()}>
            Skip to My Dashboard
          </a>
        </div>
      </div>
    );
  }
}
